(function () {
  'use strict';

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }
    return '£' + (cents / 100).toFixed(2);
  }

  function SsProductPage(root) {
    this.root = root;
    var jsonEl = qs('[data-ss-product-json]', root);
    var settingsEl = qs('[data-ss-product-settings]', root);
    if (!jsonEl || !settingsEl) return;
    try {
      this.product = JSON.parse(jsonEl.textContent);
      this.settings = JSON.parse(settingsEl.textContent);
    } catch (e) {
      return;
    }
    if (!this.product || !this.product.variants) return;
    this.currentVariant = this.getVariantFromOptions();
    this.galleryIndex = 0;
    this.init();
  }

  SsProductPage.prototype.getSelectedOptions = function () {
    var options = [];
    qsa('.ss-pdp-opt', this.root).forEach(function (fieldset) {
      var idx = parseInt(fieldset.getAttribute('data-option-index'), 10);
      var select = qs('[data-ss-option-select]', fieldset);
      if (select) {
        options[idx] = select.value;
        return;
      }
      var checked = qs('[data-ss-option-input]:checked', fieldset);
      if (checked) options[idx] = checked.value;
    });
    if (!options.length && this.product.variants.length === 1) {
      return this.product.variants[0].options.slice();
    }
    return options;
  };

  SsProductPage.prototype.getVariantFromOptions = function () {
    var selected = this.getSelectedOptions();
    var found = this.product.variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selected[i]; });
    });
    return found || this.product.variants[0];
  };

  SsProductPage.prototype.findVariant = function (optionIndex, value) {
    var selected = this.getSelectedOptions();
    selected[optionIndex] = value;
    return this.product.variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selected[i]; });
    });
  };

  SsProductPage.prototype.updateAvailability = function () {
    var self = this;
    qsa('.ss-pdp-opt', this.root).forEach(function (fieldset) {
      var optIndex = parseInt(fieldset.getAttribute('data-option-index'), 10);
      qsa('[data-ss-option-input]', fieldset).forEach(function (input) {
        var variant = self.findVariant(optIndex, input.value);
        input.disabled = !variant || !variant.available;
      });
    });
  };

  SsProductPage.prototype.updateUI = function () {
    this.currentVariant = this.getVariantFromOptions();
    var v = this.currentVariant;
    if (!v) return;

    var priceEl = qs('[data-ss-price]', this.root);
    var compareEl = qs('[data-ss-compare]', this.root);
    var saveEl = qs('[data-ss-save]', this.root);
    var input = qs('[data-ss-variant-input]', this.root);
    var atc = qs('[data-ss-pdp-atc]', this.root);
    var atcLabel = qs('[data-ss-atc-label]', this.root);
    var stock = qs('[data-ss-stock-msg]', this.root);
    var stickyPrice = qs('[data-ss-sticky-price]', this.root);
    var stickyVariant = qs('[data-ss-sticky-variant]', this.root);
    var unitEl = qs('[data-ss-unit-price]', this.root);
    var volInput = qs('[data-ss-liquid-volume]', this.root);

    if (input) input.value = v.id;
    if (priceEl) priceEl.textContent = formatMoney(v.price, this.settings.moneyFormat);

    if (unitEl && volInput && volInput.value) {
      var vol = parseFloat(volInput.value, 10);
      if (vol > 0) {
        unitEl.textContent = '(' + formatMoney(Math.round(v.price / vol), this.settings.moneyFormat) + '/ml)';
      }
    }

    if (compareEl) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        compareEl.textContent = formatMoney(v.compare_at_price, this.settings.moneyFormat);
        compareEl.hidden = false;
        if (saveEl) {
          var save = v.compare_at_price - v.price;
          var pct = Math.round(save * 100 / v.compare_at_price);
          saveEl.textContent = 'Save ' + formatMoney(save, this.settings.moneyFormat) + ' (' + pct + '%)';
          saveEl.hidden = false;
        }
      } else {
        compareEl.hidden = true;
        if (saveEl) saveEl.hidden = true;
      }
    }

    if (atc) {
      atc.disabled = !v.available;
      if (atcLabel) {
        var label = this.settings.atcLabel || 'Add to cart';
        atcLabel.textContent = v.available
          ? label.toUpperCase()
          : this.settings.soldOutLabel.toUpperCase();
      }
    }

    if (stock) {
      if (!v.available) {
        stock.textContent = this.settings.soldOutLabel;
        stock.style.color = '#d62828';
      } else if (v.inventory_management === 'shopify' && v.inventory_quantity > 0 && v.inventory_quantity <= this.settings.lowStockThreshold) {
        stock.textContent = 'Low stock, only ' + v.inventory_quantity + ' left';
        stock.style.color = '#d62828';
      } else {
        stock.textContent = this.settings.inStockLabel;
        stock.style.color = '#2d8a4e';
      }
    }

    if (stickyPrice) stickyPrice.textContent = formatMoney(v.price, this.settings.moneyFormat);
    if (stickyVariant) stickyVariant.textContent = v.title !== 'Default Title' ? ' · ' + v.title : '';

    var storeWrap = qs('[data-ss-pdp-store]', this.root);
    if (storeWrap) {
      storeWrap.setAttribute('data-variant-id', v.id);
      var pickup = qs('pickup-availability', storeWrap);
      if (pickup) {
        pickup.setAttribute('data-variant-id', v.id);
        if (typeof pickup.fetchAvailability === 'function') pickup.fetchAvailability(v.id);
      }
    }

    qsa('[data-ss-opt-selected]', this.root).forEach(function (el) {
      var fieldset = el.closest('.ss-pdp-opt');
      if (!fieldset) return;
      var select = qs('[data-ss-option-select]', fieldset);
      if (select) {
        el.textContent = select.value;
        return;
      }
      var idx = parseInt(fieldset.getAttribute('data-option-index'), 10);
      var checked = qs('[data-option-index="' + idx + '"]:checked', fieldset);
      if (checked) el.textContent = checked.value;
    });

    qsa('[data-ss-pdp-picker]', this.root).forEach(function (picker) {
      var select = qs('[data-ss-option-select]', picker);
      var valueEl = qs('[data-ss-picker-value]', picker);
      var trigger = qs('[data-ss-picker-trigger]', picker);
      if (!select || !valueEl) return;
      valueEl.textContent = select.value;
      if (trigger) trigger.setAttribute('aria-label', (picker.querySelector('.ss-pdp-picker__label') || {}).textContent + ': ' + select.value);
      qsa('[data-ss-picker-option]', picker).forEach(function (btn) {
        var on = btn.getAttribute('data-value') === select.value;
        btn.classList.toggle('is-selected', on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    });

    if (v.featured_media && v.featured_media.id) {
      this.goToMedia(v.featured_media.id);
    }

    this.updateAvailability();
    this.updateUrl(v.id);
  };

  SsProductPage.prototype.updateUrl = function (variantId) {
    if (!window.history.replaceState) return;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url.toString());
  };

  SsProductPage.prototype.bindVariants = function () {
    var self = this;
    this.root.addEventListener('change', function (e) {
      if (!e.target.matches('[data-ss-option-input], [data-ss-option-select]')) return;
      self.updateUI();
    });
    this.updateAvailability();
  };

  SsProductPage.prototype.bindQty = function () {
    var input = qs('[data-ss-qty-input]', this.root);
    if (!input) return;
    var minus = qs('[data-ss-qty-minus]', this.root);
    var plus = qs('[data-ss-qty-plus]', this.root);
    if (minus) {
      minus.addEventListener('click', function () {
        var val = Math.max(1, parseInt(input.value, 10) - 1);
        input.value = val;
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        input.value = Math.max(1, parseInt(input.value, 10) + 1);
      });
    }
  };

  SsProductPage.prototype.bindForm = function () {
    var self = this;
    var form = qs('[data-ss-pdp-form]', this.root);
    if (!form || !window.routes) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var err = qs('[data-ss-pdp-error]', self.root);
      if (err) err.hidden = true;

      if (!self.currentVariant || !self.currentVariant.available) {
        if (err) {
          err.textContent = 'Please select an available option before adding to cart.';
          err.hidden = false;
        }
        return;
      }

      var atc = qs('[data-ss-pdp-atc]', self.root);
      var loading = qs('[data-ss-atc-loading]', self.root);
      var label = qs('[data-ss-atc-label]', self.root);
      if (atc) atc.disabled = true;
      if (loading) loading.hidden = false;
      if (label) label.hidden = true;

      var fd = new FormData(form);
      fd.append('sections', 'cart-drawer,cart-icon-bubble');
      fd.append('sections_url', window.location.pathname);

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: fd
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || 'Add failed');
          document.dispatchEvent(new CustomEvent('ss:cart-added', { detail: res }));
        })
        .catch(function (ex) {
          if (err) {
            err.textContent = ex.message || 'We could not add this item. Please try again.';
            err.hidden = false;
          }
        })
        .finally(function () {
          if (atc) atc.disabled = !self.currentVariant.available;
          if (loading) loading.hidden = true;
          if (label) label.hidden = false;
        });
    });
  };

  /* Gallery */
  SsProductPage.prototype.getSlides = function () {
    return qsa('[data-ss-gal-slide]', this.root);
  };

  SsProductPage.prototype.goToSlide = function (index) {
    var slides = this.getSlides();
    if (!slides.length) return;
    this.galleryIndex = (index + slides.length) % slides.length;
    slides.forEach(function (s, i) {
      s.classList.toggle('is-active', i === this.galleryIndex);
    }, this);
    qsa('[data-ss-gal-thumb]', this.root).forEach(function (t, i) {
      t.classList.toggle('is-active', i === this.galleryIndex);
      t.setAttribute('aria-selected', i === this.galleryIndex ? 'true' : 'false');
    }, this);
    qsa('.ss-pdp-gal__dot', this.root).forEach(function (d, i) {
      d.classList.toggle('is-active', i === this.galleryIndex);
    }, this);
    if (typeof this.syncLightbox === 'function') this.syncLightbox();
  };

  SsProductPage.prototype.goToMedia = function (mediaId) {
    var slides = this.getSlides();
    var idx = slides.findIndex(function (s) {
      return parseInt(s.getAttribute('data-media-id'), 10) === mediaId;
    });
    if (idx >= 0) this.goToSlide(idx);
  };

  SsProductPage.prototype.bindGallery = function () {
    var self = this;
    var gal = qs('[data-ss-pdp-gallery]', this.root);
    if (!gal) return;

    qs('[data-ss-gal-prev]', gal) && qs('[data-ss-gal-prev]', gal).addEventListener('click', function () {
      self.goToSlide(self.galleryIndex - 1);
    });
    qs('[data-ss-gal-next]', gal) && qs('[data-ss-gal-next]', gal).addEventListener('click', function () {
      self.goToSlide(self.galleryIndex + 1);
    });
    qsa('[data-ss-gal-thumb]', gal).forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.goToSlide(parseInt(btn.getAttribute('data-index'), 10));
      });
    });

    var viewport = qs('[data-ss-gal-viewport]', gal);
    var navTimer = null;
    function showNavBriefly() {
      gal.classList.add('is-nav-visible');
      if (navTimer) clearTimeout(navTimer);
      navTimer = setTimeout(function () {
        gal.classList.remove('is-nav-visible');
      }, 2600);
    }
    if (viewport) {
      var startX = 0;
      viewport.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        showNavBriefly();
      }, { passive: true });
      viewport.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) self.goToSlide(self.galleryIndex + (dx < 0 ? 1 : -1));
      }, { passive: true });
      viewport.addEventListener('pointerenter', function () {
        if (window.matchMedia('(hover: hover)').matches) gal.classList.add('is-nav-visible');
      });
      viewport.addEventListener('pointerleave', function () {
        if (window.matchMedia('(hover: hover)').matches) gal.classList.remove('is-nav-visible');
      });
    }
  };

  SsProductPage.prototype.bindPickers = function () {
    var self = this;

    function closeAll(except) {
      qsa('[data-ss-pdp-picker]', self.root).forEach(function (picker) {
        if (picker === except) return;
        var panel = qs('[data-ss-picker-panel]', picker);
        var trigger = qs('[data-ss-picker-trigger]', picker);
        if (panel) panel.hidden = true;
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    }

    qsa('[data-ss-pdp-picker]', this.root).forEach(function (picker) {
      var trigger = qs('[data-ss-picker-trigger]', picker);
      var panel = qs('[data-ss-picker-panel]', picker);
      var select = qs('[data-ss-option-select]', picker);
      var search = qs('[data-ss-picker-search]', picker);
      var valueEl = qs('[data-ss-picker-value]', picker);
      if (!trigger || !panel || !select) return;

      function filterOptions(q) {
        var query = (q || '').toLowerCase().trim();
        qsa('[data-ss-picker-option]', picker).forEach(function (btn) {
          var li = btn.parentElement;
          var match = !query || btn.textContent.toLowerCase().indexOf(query) >= 0;
          li.style.display = match ? '' : 'none';
        });
      }

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var willOpen = panel.hidden;
        closeAll(picker);
        panel.hidden = !willOpen;
        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        if (willOpen) {
          if (search) {
            search.value = '';
            filterOptions('');
            setTimeout(function () { search.focus(); }, 60);
          }
          var selected = qs('.ss-pdp-picker__option.is-selected', picker);
          if (selected) selected.scrollIntoView({ block: 'nearest' });
        }
      });

      if (search) {
        search.addEventListener('input', function () { filterOptions(search.value); });
        search.addEventListener('keydown', function (e) { e.stopPropagation(); });
      }

      qsa('[data-ss-picker-option]', picker).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var val = btn.getAttribute('data-value');
          select.value = val;
          if (valueEl) valueEl.textContent = val;
          qsa('[data-ss-picker-option]', picker).forEach(function (b) {
            b.classList.toggle('is-selected', b === btn);
            b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
          });
          panel.hidden = true;
          trigger.setAttribute('aria-expanded', 'false');
          trigger.setAttribute('aria-label', (qs('.ss-pdp-picker__label', picker) || {}).textContent + ': ' + val);
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-ss-pdp-picker]')) closeAll();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  };

  SsProductPage.prototype.bindTabs = function () {
    var root = qs('[data-ss-pdp-tabs]', this.root);
    if (!root) return;
    var tabs = qsa('[data-ss-tab]', root);
    var panels = qsa('[data-ss-tab-panel]', root);
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-ss-tab');
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          var show = panel.getAttribute('data-ss-tab-panel') === id;
          panel.classList.toggle('is-active', show);
          panel.hidden = !show;
        });
      });
    });
  };

  SsProductPage.prototype.bindParallax = function () {
    /* Disabled: mobile/desktop transform caused ghost peaking of absolute slides */
  };

  SsProductPage.prototype.bindStoreCheck = function () {
    var wrap = qs('[data-ss-pdp-store]', this.root);
    if (!wrap) return;
    var btn = qs('[data-ss-store-check]', wrap);
    var input = qs('[data-ss-store-input]', wrap);
    var results = qs('[data-ss-store-results]', wrap);
    var pickup = qs('pickup-availability', wrap);
    var self = this;
    if (!btn || !results) return;

    function normaliseQuery(q) {
      return (q || '').toLowerCase().replace(/\s+/g, ' ').trim();
    }

    function matchesQuery(blob, query) {
      if (!query) return true;
      var compactBlob = blob.replace(/\s+/g, '');
      var compactQuery = query.replace(/\s+/g, '');
      if (blob.indexOf(query) >= 0) return true;
      // UK postcodes often typed without space (e.g. M11AA)
      if (compactQuery.length >= 5 && compactBlob.indexOf(compactQuery) >= 0) return true;
      var parts = query.split(' ');
      return parts.every(function (p) { return !p || blob.indexOf(p) >= 0; });
    }

    function renderStores(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var items = doc.querySelectorAll('.pickup-availability-list__item');
      var query = normaliseQuery(input && input.value);
      if (!items.length) {
        results.innerHTML = '<p class="ss-pdp-store__empty">No in-store pickup locations are configured for this product yet. Use Find a Smoke Shop near you for store details.</p>';
        return;
      }
      var out = '<ul class="ss-pdp-store__list">';
      var count = 0;
      items.forEach(function (li) {
        var name = li.querySelector('h3') ? li.querySelector('h3').textContent.trim() : 'Store';
        var statusEl = li.querySelector('.pickup-availability-preview');
        var status = statusEl ? statusEl.textContent.replace(/\s+/g, ' ').trim() : '';
        var addrEl = li.querySelector('address');
        var addr = addrEl ? addrEl.textContent.replace(/\s+/g, ' ').trim() : '';
        var phoneEl = addrEl && addrEl.querySelector('p');
        var phone = phoneEl ? phoneEl.textContent.trim() : '';
        var blob = (name + ' ' + addr).toLowerCase();
        if (!matchesQuery(blob, query)) return;
        var available = /pick.?up available|available for pickup|in stock/i.test(status)
          || (status.length > 0 && status.toLowerCase().indexOf('unavailable') < 0 && status.indexOf('tick') >= 0)
          || (status.length > 0 && !/unavailable|out of stock/i.test(status) && /available|usually ready|ready in/i.test(status));
        if (!status) available = false;
        out += '<li><strong>' + name + '</strong>';
        out += '<span class="ss-pdp-store__status' + (available ? '' : ' is-unavailable') + '">';
        out += available ? 'In stock for pickup' : 'Currently unavailable for pickup';
        out += '</span>';
        if (status) out += '<span class="visually-hidden">' + status + '</span>';
        if (addr) out += '<p class="ss-pdp-store__addr">' + addr + '</p>';
        if (phone) out += '<p class="ss-pdp-store__phone"><a href="tel:' + phone.replace(/[^\d+]/g, '') + '">' + phone + '</a></p>';
        out += '</li>';
        count++;
      });
      out += '</ul>';
      if (!count) {
        results.innerHTML = '<p class="ss-pdp-store__empty">No stores match that location. Try a nearby postcode or town, or open the Store Locator.</p>';
        return;
      }
      results.innerHTML = out;
    }

    function check() {
      var variantId = self.currentVariant ? self.currentVariant.id : wrap.getAttribute('data-variant-id');
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      if (!root.endsWith('/')) root += '/';
      wrap.setAttribute('data-variant-id', variantId);
      if (pickup) {
        pickup.setAttribute('data-variant-id', variantId);
        pickup.setAttribute('available', '');
      }
      results.hidden = false;
      results.innerHTML = '<p class="ss-pdp-store__loading">Checking store availability…</p>';
      btn.disabled = true;
      fetch(root + 'variants/' + variantId + '/?section_id=pickup-availability')
        .then(function (r) {
          if (!r.ok) throw new Error('pickup');
          return r.text();
        })
        .then(renderStores)
        .catch(function () {
          results.innerHTML = '<p class="ss-pdp-store__empty">Unable to check stores right now. Please try again or contact us for availability.</p>';
        })
        .finally(function () {
          btn.disabled = false;
        });
    }

    btn.addEventListener('click', check);
    if (input) {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); check(); }
      });
    }
  };

  SsProductPage.prototype.bindSticky = function () {
    var sticky = qs('[data-ss-pdp-sticky]', this.root);
    var panel = qs('[data-ss-pdp-panel]', this.root);
    var atc = qs('[data-ss-pdp-atc]', this.root);
    if (!sticky || !panel) return;

    var stickyBtn = qs('[data-ss-sticky-atc]', sticky);
    if (stickyBtn && atc) {
      stickyBtn.addEventListener('click', function () { atc.click(); });
    }

    sticky.removeAttribute('hidden');

    var syncSticky = function (show) {
      sticky.classList.toggle('is-visible', show);
      document.documentElement.classList.toggle('ss-pdp-sticky-on', !!show);
    };

    if (!('IntersectionObserver' in window)) {
      syncSticky(true);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        syncSticky(!entry.isIntersecting);
      });
    }, { threshold: 0, rootMargin: '0px 0px -15% 0px' });
    io.observe(atc || panel);

    requestAnimationFrame(function () {
      var target = atc || panel;
      var rect = target.getBoundingClientRect();
      if (rect.bottom < 80 || rect.top > window.innerHeight * 0.72) {
        syncSticky(true);
      }
    });
  };

  SsProductPage.prototype.bindDispatch = function () {
    var el = qs('[data-ss-dispatch]', this.root);
    if (!el) return;
    var cutoff = parseInt(el.getAttribute('data-cutoff'), 10) || 15;
    var now = new Date();
    var end = new Date();
    end.setHours(cutoff, 0, 0, 0);
    if (now >= end) {
      end.setDate(end.getDate() + 1);
      el.textContent = 'Order by ' + cutoff + ':00 tomorrow for next dispatch window.';
      return;
    }
    var diff = end - now;
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    el.textContent = 'Order within ' + h + 'h ' + m + 'm for dispatch today.';
  };

  SsProductPage.prototype.bindBundle = function () {
    var form = qs('[data-ss-pdp-bundle]', this.root);
    if (!form) return;
    var totalEl = qs('[data-ss-bundle-total]', form);
    var mainPrice = this.currentVariant.price;

    function calc() {
      var total = mainPrice;
      qsa('[data-ss-bundle-item]:checked', form).forEach(function (cb) {
        total += parseInt(cb.getAttribute('data-price'), 10) || 0;
      });
      if (totalEl) totalEl.textContent = formatMoney(total, this.settings.moneyFormat);
    }
    calc.call(this);
    form.addEventListener('change', calc.bind(this));

    var self = this;
    var addBtn = qs('[data-ss-bundle-add]', form);
    if (!addBtn) return;
    addBtn.addEventListener('click', function () {
      var items = [{ id: self.currentVariant.id, quantity: 1 }];
      qsa('[data-ss-bundle-item]:checked', form).forEach(function (cb) {
        items.push({ id: parseInt(cb.value, 10), quantity: 1 });
      });
      var chain = Promise.resolve();
      items.forEach(function (item) {
        chain = chain.then(function () {
          var fd = new FormData();
          fd.append('id', item.id);
          fd.append('quantity', item.quantity);
          return fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
            body: fd
          }).then(function (r) { return r.json(); });
        });
      });
      chain.then(function (res) {
        document.dispatchEvent(new CustomEvent('ss:cart-added', { detail: res || {} }));
      });
    });
  };

  SsProductPage.prototype.loadComplementary = function () {
    var wrap = qs('[data-ss-pdp-complementary]', this.root);
    if (!wrap) return;
    var grid = qs('[data-ss-comp-grid]', wrap);
    var id = wrap.getAttribute('data-product-id');
    var limit = wrap.getAttribute('data-limit') || 4;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var self = this;

    fetch(root + 'recommendations/products.json?product_id=' + id + '&limit=' + limit + '&intent=complementary')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.products || !data.products.length || !grid) {
          wrap.style.display = 'none';
          return;
        }
        grid.innerHTML = data.products.map(function (p) {
          var img = p.featured_image
            ? '<img src="' + p.featured_image + '" alt="" loading="lazy" width="72" height="72">'
            : '';
          var vid = p.variants && p.variants[0] ? p.variants[0].id : '';
          return '<article class="ss-pdp-comp__card">' + img +
            '<div><p class="ss-pdp-comp__card-title"><a href="' + p.url + '">' + p.title + '</a></p>' +
            '<p class="ss-pdp-comp__card-price">' + formatMoney(p.price, self.settings.moneyFormat) + '</p></div>' +
            '<button type="button" class="ss-pdp-comp__card-btn" data-ss-comp-add data-variant-id="' + vid + '">Add</button></article>';
        }).join('');
      })
      .catch(function () { wrap.style.display = 'none'; });

    this.root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ss-comp-add]');
      if (!btn || !window.routes) return;
      e.preventDefault();
      var fd = new FormData();
      fd.append('id', btn.getAttribute('data-variant-id'));
      fd.append('quantity', '1');
      fd.append('sections', 'cart-drawer,cart-icon-bubble');
      fd.append('sections_url', window.location.pathname);
      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: fd
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || 'Add failed');
          document.dispatchEvent(new CustomEvent('ss:cart-added', { detail: res }));
          btn.textContent = 'Added';
        })
        .catch(function () {
          btn.textContent = 'Add';
        });
    });
  };

  SsProductPage.prototype.bindFlavours = function () {
    var toggle = qs('[data-ss-flavour-toggle]', this.root);
    var grid = qs('[data-ss-flavour-grid]', this.root);
    if (!toggle || !grid) return;
    toggle.addEventListener('click', function () {
      var expanded = grid.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      toggle.textContent = expanded ? 'Show fewer flavours' : toggle.getAttribute('data-label-default') || toggle.textContent;
    });
    toggle.setAttribute('data-label-default', toggle.textContent);
  };

  SsProductPage.prototype.loadRecommendations = function () {
    var wrap = qs('[data-ss-pdp-recs]', this.root);
    if (!wrap) return;
    var grid = qs('[data-ss-recs-grid]', wrap);
    var id = wrap.getAttribute('data-product-id');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'recommendations/products.json?product_id=' + id + '&limit=8')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.products || !data.products.length || !grid) {
          wrap.style.display = 'none';
          return;
        }
        grid.innerHTML = data.products.map(function (p) {
          var imgSrc = p.featured_image || '';
          var img = imgSrc
            ? '<img src="' + imgSrc + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy" width="400" height="400">'
            : '';
          var price = formatMoney(p.price, this.settings.moneyFormat);
          var compare = p.compare_at_price > p.price
            ? '<span class="ss-pdp-rec-card__compare">' + formatMoney(p.compare_at_price, this.settings.moneyFormat) + '</span>'
            : '';
          var vendor = p.vendor ? '<span class="ss-pdp-rec-card__brand">' + p.vendor.toUpperCase() + '</span>' : '';
          return '<article class="ss-pdp-rec-card">' +
            '<a href="' + p.url + '" class="ss-pdp-rec-card__media">' + img + '</a>' +
            '<div class="ss-pdp-rec-card__body">' + vendor +
            '<h3 class="ss-pdp-rec-card__title"><a href="' + p.url + '">' + p.title + '</a></h3>' +
            '<div class="ss-pdp-rec-card__price-row"><span class="ss-pdp-rec-card__price">' + price + '</span>' + compare + '</div>' +
            '</div></article>';
        }.bind(this)).join('');
      }.bind(this))
      .catch(function () { wrap.style.display = 'none'; });

    if (!grid) return;
    qs('[data-ss-recs-prev]', wrap) && qs('[data-ss-recs-prev]', wrap).addEventListener('click', function () {
      var card = grid.querySelector('.ss-pdp-rec-card');
      var step = card ? card.getBoundingClientRect().width + 16 : grid.clientWidth;
      grid.scrollBy({ left: -step, behavior: 'smooth' });
    });
    qs('[data-ss-recs-next]', wrap) && qs('[data-ss-recs-next]', wrap).addEventListener('click', function () {
      var card = grid.querySelector('.ss-pdp-rec-card');
      var step = card ? card.getBoundingClientRect().width + 16 : grid.clientWidth;
      grid.scrollBy({ left: step, behavior: 'smooth' });
    });
  };

  SsProductPage.prototype.bindAccordions = function () {
    qsa('[data-ss-acc]', this.root).forEach(function (acc) {
      var trigger = qs('[data-ss-acc-trigger]', acc);
      var body = qs('[data-ss-acc-body]', acc);
      if (!trigger || !body) return;

      /* Remove the HTML hidden attribute so CSS can control height */
      body.removeAttribute('hidden');
      body.style.maxHeight = '0';

      trigger.addEventListener('click', function () {
        var isOpen = acc.classList.contains('is-open');
        if (isOpen) {
          acc.classList.remove('is-open');
          body.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          body.style.maxHeight = body.scrollHeight + 'px';
          /* Force reflow then collapse */
          requestAnimationFrame(function () {
            body.style.maxHeight = '0';
          });
        } else {
          acc.classList.add('is-open');
          body.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          body.style.maxHeight = body.scrollHeight + 'px';
          /* After transition, set to auto so content resize works */
          body.addEventListener('transitionend', function onEnd() {
            if (acc.classList.contains('is-open')) body.style.maxHeight = 'none';
            body.removeEventListener('transitionend', onEnd);
          });
        }
      });
    });
  };

  SsProductPage.prototype.bindReviews = function () {
    var openBtn = qs('[data-ss-reviews-open]', this.root);
    var formWrap = openBtn && document.getElementById(openBtn.getAttribute('aria-controls'));
    if (!openBtn || !formWrap) return;

    function setOpen(open) {
      formWrap.hidden = !open;
      openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        formWrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        var first = qs('input, textarea, select, button', formWrap);
        if (first) first.focus();
      }
    }

    openBtn.addEventListener('click', function () {
      setOpen(formWrap.hidden !== false);
    });

    var cancelBtn = qs('[data-ss-reviews-close]', formWrap);
    if (cancelBtn) {
      cancelBtn.addEventListener('click', function () {
        setOpen(false);
        openBtn.focus();
      });
    }

    // Keep form open after successful submit / validation errors
    if (qs('.ss-pdp-review-form__success, .ss-pdp-review-form__error', formWrap)) {
      setOpen(true);
    }
  };

  SsProductPage.prototype.init = function () {
    var urlVariant = new URLSearchParams(window.location.search).get('variant');
    if (urlVariant) {
      var v = this.product.variants.find(function (x) { return String(x.id) === String(urlVariant); });
      if (v) {
        v.options.forEach(function (val, i) {
          var fieldset = qs('.ss-pdp-opt[data-option-index="' + i + '"]', this.root);
          if (!fieldset) return;
          var select = qs('[data-ss-option-select]', fieldset);
          if (select) {
            select.value = val;
            return;
          }
          qsa('[data-option-index="' + i + '"]', fieldset).forEach(function (input) {
            if (input.value === val) input.checked = true;
          });
        }, this);
      }
    }
    this.bindVariants();
    this.bindPickers();
    this.bindQty();
    this.bindForm();
    this.bindGallery();
    this.bindParallax();
    this.bindTabs();
    this.bindAccordions();
    this.bindReviews();
    this.bindStoreCheck();
    this.bindSticky();
    this.bindDispatch();
    this.bindBundle();
    this.loadComplementary();
    this.loadRecommendations();
    this.bindFlavours();
    this.updateUI();
  };

  document.addEventListener('DOMContentLoaded', function () {
    qsa('[data-ss-product]').forEach(function (el) {
      try {
        new SsProductPage(el);
      } catch (e) {}
    });
  });
})();
